import React from 'react';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

export default function PaginationComp({
  totalPageSize,
  page,
  size,
  handleChange,
  isDisplayDot,
  ...others
}) {
  const customRenderItems = [];

  for (let i = 1; i <= totalPageSize; i++) {
    if (i === 1 || i === page || i === page - 1 || i === totalPageSize) {
      customRenderItems.push(i);
    }
  }

  const visiblePages = [...new Set(customRenderItems)].sort((a, b) => a - b);

  return (
    <Pagination
      count={totalPageSize}
      page={page}
      onChange={(_, value) => {
        if (value <= totalPageSize) {
          handleChange(value);
        }
      }}
      size={size || 'small'}
      color="primary"
      renderItem={(item) => {
        const { type, page: itemPage } = item;
        if (type === 'previous' || type === 'next') {
          return <PaginationItem {...item} />;
        }
        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
          return <PaginationItem {...item} />;
        }
        if (visiblePages.includes(itemPage)) {
          return <PaginationItem {...item} />;
        }
        return <PaginationItem {...item} style={{ display: 'none' }} />;
      }}
      siblingCount={0}
      boundaryCount={1}
      {...others}
    />
  );
}
